import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: 'How does pay after activation work?',
      answer: 'We believe in zero-risk transactions. First, you contact us with your chosen offer. We then work with you to activate the subscription in real-time. Once you confirm that the subscription is active and working on your account, only then do you make the payment. If activation fails for any reason, you pay nothing.'
    },
    {
      question: 'Is Meta Learners affiliated with YouTube/Apple/Crunchyroll or other brands?',
      answer: 'No. Meta Learners is an independent service and is not affiliated with, endorsed by, or partnered with any of the brands we help activate. We provide a service to help customers access premium subscriptions more affordably, but we are not official resellers or partners of these companies.'
    },
    {
      question: 'What if activation fails?',
      answer: 'If we cannot successfully activate your subscription, you do not pay anything. It\'s that simple. We will work with you to troubleshoot any issues, and if necessary, suggest alternative options or offers. Your satisfaction and security are our priorities, and we never charge for unsuccessful activations.'
    },
    {
      question: 'How fast is delivery?',
      answer: 'Activation times vary depending on the service and current demand, but most subscriptions are activated within 5-30 minutes. Some may be faster, others may take up to 45 minutes. We\'ll give you an estimated timeframe when you contact us, and we\'ll keep you updated throughout the process.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'Payment methods are discussed and confirmed via Instagram DM. We offer multiple secure payment options to make the process convenient for you. All payment details are shared privately in our conversation once activation is confirmed.'
    },
    {
      question: 'Is this available in my country?',
      answer: 'Service availability depends on your location and the specific subscription you\'re interested in. Some offers have regional restrictions or eligibility requirements. Contact us on Instagram with your location and desired service, and we\'ll confirm whether we can help you.'
    },
    {
      question: 'What kind of support do you provide?',
      answer: 'We provide comprehensive support from your first message to successful activation and beyond. This includes answering questions, guiding you through activation steps, troubleshooting any issues, and being available if you need help after activation. We\'re committed to ensuring you have a smooth experience.'
    },
    {
      question: 'Are these subscriptions safe and legitimate?',
      answer: 'Yes. We use legitimate activation methods and work within the terms of service. We prioritize your account safety and never engage in practices that would put your account at risk. Our pay-after-activation model and thousands of satisfied customers demonstrate our commitment to legitimate service.'
    },
    {
      question: 'Can I get a refund?',
      answer: 'Since you only pay after confirming activation works, refunds are rarely needed. However, if you encounter issues after payment, contact us immediately. We\'ll work to resolve the problem or discuss refund options based on the specific situation. Your satisfaction matters to us.'
    }
  ];

  return (
    <section id="faq" className="py-20 px-4">
      <div className="container mx-auto">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground">
            Frequently Asked <span className="gradient-text">Questions</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Everything you need to know about our service
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="glass-card px-6 rounded-lg border-border/50"
              >
                <AccordionTrigger className="text-left text-foreground hover:text-primary transition-colors py-5">
                  <span className="font-semibold">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
